import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridColumn } from '../grid-control.model';
@Pipe({
  name: 'valueTransform'
})
export class ValueTransformPipe implements PipeTransform {
  // tslint:disable-next-line: max-line-length
  transform(value: any, rowData: GridItem, column: GridColumn): string {
    if (column.transform) {
      return column.transform(value, rowData);
    }
    return value;
  }
}
